<template>
  <div class="login-container" :style="{'background-image': 'url(' + require('~/assets/bg/login-bg.png') + ')'}">
    <div class="login-form_container p-l-55 p-r-55 p-t-65 p-b-50 text-center">
      <h2>
        Восстановить доступ
      </h2>
      <template v-if="!submitted && !isError">
        <p>Введите адрес электронной почты, указанной при регистрации и мы вышлем вам новый пароль</p>

        <div class="login-form_enter">
          <div class="login-form_item">
            <b-form-input v-model.trim="email" type="email" placeholder="Эл. почта" />
          </div>
          <div class="login-form_item">
            <b-button variant="primary" :disabled="!email" @click="resetPassword">
              Отправить
            </b-button>
          </div>
        </div>
      </template>

      <template v-if="submitted && !isError">
        <p>Новый пароль выслан</p>
        <p>Пожалуйста, проверьте вашу электронную почту</p>

        <div class="login-form_enter">
          <div class="login-form_item">
            <b-button variant="primary" @click="$router.push('/login')">
              Ок
            </b-button>
          </div>
        </div>
      </template>

      <template v-if="isError">
        <p>К сожалению, данного логина не существует</p>
        <div class="login-form_enter">
          <div class="login-form_item">
            <b-button variant="primary" @click="$router.push('/login')">
              Ок
            </b-button>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {
      isError: false,
      submitted: false,
      email: null
    }
  },
  methods: {
    async resetPassword () {
      try {
        await this.$axios.$post('/api/cabinet/resetPassword', {
          email: this.email
        })
        this.submitted = true
      } catch (e) {
        this.isError = true
      }
    }
  }
}
</script>

<style lang="scss">

.login {
  &-container {
    width: 100%;
    min-height: 100vh;
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: flex-start;
    padding: 190px 20px 0;
    background-color: #F8F9FC;
    background-size: 100% auto;
    background-position: center top 110px;
    background-repeat: no-repeat;
  }
  &-form {
    &_container {
      width: 640px;
      background: #fff;
      overflow: hidden;
      padding: 50px 0;
      -webkit-border-radius:3px;
      -moz-border-radius:3px;
      border-radius:3px;
      > h2 {
        font-weight: 500;
        font-size: 36px;
        line-height: 33px;
        margin: 0 0 12px;
      }
      > p {
        font-size: 13px;
        line-height: 20px;
        padding: 0 40px;
        margin: 0 0 26px;
      }
      .nav-tabs {
        border-bottom: 2px solid #CAD0DF;
        .nav-link {
          border: none;
          width: 130px;
          font-size: 11px;
          text-transform: uppercase;
          line-height: 20px;
          padding: 0 0 6px;
          color: #1B2E4B;
          &.active {
            color: #0168FA;
            border-bottom: 2px solid #0168FA;
          }
        }
        .nav-item {
          margin-bottom: -2px;
        }
      }
      .btn {
        font-size: 13px;
        width: 260px;
        height: 36px;
        margin: 0 auto;
      }

      .form-control {
        text-align: center;
        font-size: 13px;
        height: 36px;
        width: 260px;
        margin: 0 auto;
      }
    }
    &_enter {
      padding: 45px 20px 0;
    }
    &_e-signature {
      padding: 45px 20px 30px;
      button {
        min-width: 260px;
      }
    }
    &_footer {
      padding: 33px 0 0;
      &-item {
        margin: 10px 0 0;
        font-size: 0;
        &:first-child {
          margin: 0;
        }
      }
      a {
        color: #8392A5;
        display: inline-block;
        line-height: 20px;
        font-size: 12px;
      }
    }
    &_item {
      margin: 14px 0 0;
      text-align: center;
      &:first-child {
        margin: 0;
      }
    }
  }
}
.ws-error {
  color: #FF0000;
  font-size: 12px;
  line-height: 20px;
  display: block;
}
</style>
